import type { ProductList } from 'src/app/shared/hooks/useProductSetFromCart';

export const getFeaturesByProductId = (
  products: ProductList,
  itemId: string,
) => {
  const features = products.items.find((p) => p.id === itemId)?.features;
  if (features) {
    return features;
  }
  return null;
};
